import Footer from "../../layouts/footer/Footer";
import Header from "../../layouts/header/Header";
import VerificationMain from "../../layouts/main/account/VerificationMain";

const Login = () => {
  return (
    <div>
      <Header />
      <VerificationMain />
      {/* <Footer /> */}
    </div>
  );
};

export default Login;
